<template>
  <div>
    <div class="inner_banner">
      <img src="~@/assets/image/aboutusbanner.png">
      <div class="container bannertxt">
        <div>
          <div class="banner_title" style="color: #161616">关于我们</div>
          <div class="banner_sub_title" style="color: #161616">展特易/关于我们</div>
        </div>
      </div>

    </div>
    <div class="zqrow">
      <div class="content container about_detail">
        <img src="@/assets/image/aboutusinfo.jpg"/>
      </div>
    </div>

    <template v-if="goodsList.length>0">
      <Pagination :totalPage="totalPage" :limit="searchOptions.limit" @changePage="handleCurrentChange">
      </Pagination>
    </template>

  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination.vue";
import {
  deepCopy
} from "@/utils";
import {
  goodsStyle
} from "@/utils";
import {
  forEach
} from "core-js/fn/dict";
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
export default {
  name: "Case",
  components: {
    Pagination
  },
  props: {},
  data() {
    return {
      loadingShow: false,
      articleList:[],
      totalPage: 0,
      detail: [],
      goodsList: [],
      showFilter: true,
      firstLoad: true, //是否初次加载
      catList: [], //分类
      allcatList: [], //所有分类,
      brandList: [], //品牌
      labelList: [], //筛选标签
      paramsList: [],
      noDataIsShow: false,
      loadingShow: false,
      banner: require("@/assets/image/first_pro.png"),
      readme: "所有产品描述",
      curcatename: "所有产品",
      allParameters: [],
      isopen: false,
      searchOptions: {
        where: {},
        limit: 15,
        page: 1,
        order: {
          key: "sort",
          sort: "asc" //默认综合排序
        }
      },
      totalPro: 0,
    };

  },
  watch: {},
  computed: {
  },
  methods: {
    getarticleInfo() {
      let where = {
        article_id: this.$route.params.goodsId
      };
      let that = this;
      this.$api.articleInfo(where).then(res => {
        if (res.status) {
          this.detail = res.data
          console.log("this.detail", this.detail);
          that.$nextTick(
              function() {
                let galleryTop = new Swiper('.lcontainer', {
                  slidesPerGroup: 1,
                  slidesPerView: 1,
                  spaceBetween: 10,
                  nextButton: '.thumd .swiper-button-next',
                  prevButton: '.thumd .swiper-button-prev',
                  observer: true,
                });
                let galleryThumbs = new Swiper('.thumd', {
                  spaceBetween: 10,
                  slidesPerView: 3,
                  touchRatio: 0.2,
                  slideToClickedSlide: true,
                  centeredSlides: true,
                  slidesPerGroup: 1,
                  grabCursor: true,
                  slidesOffsetBefore: 66,
                  slidesOffsetAfter: 66,
                  observer: true,


                });
                galleryTop.params.control = galleryThumbs;
                galleryThumbs.params.control = galleryTop;

                let galleryTop2 = new Swiper('.lcontainer2', {
                  slidesPerGroup: 1,
                  slidesPerView: 1,
                  nextButton: '.thumd2 .swiper-button-next',
                  prevButton: '.thumd2 .swiper-button-prev',
                  observer: true,
                  observeParents: true,
                });
                let galleryThumbs2 = new Swiper('.thumd2', {
                  spaceBetween: 10,
                  slidesPerView: 3,
                  touchRatio: 0.2,
                  slideToClickedSlide: true,
                  centeredSlides: true,
                  slidesPerGroup: 1,
                  grabCursor: true,
                  slidesOffsetBefore: 66,
                  slidesOffsetAfter: 66,
                  direction: 'vertical',
                  observer: true,
                  observeParents: true,
                });
                galleryTop2.params.control = galleryThumbs2;
                galleryThumbs2.params.control = galleryTop2;
              })
        }
      })
    },
    open_nav: function(k) {
      this.$set(this.allcatList[k], 'active', !this.allcatList[k].active)
    },
    //搜索分类
    selectCat(id) {
      let data = {
        page: 1,
        where: {
          cat_id: id
        }
      };
      console.log("data",data);
      this.selectedCatId = id;
      this.getArticleList(id);
    },
    isparam(id) {
      let index = this.paramsList.indexOf(id);
      console.log("index",index);
      if (index > -1) {
        return true;
      } else {
        return false;
      }
    },
    getArticleList(type_id) {
      let where = {
        type_id: type_id,
        limit:1000,
      };
      this.$api.articleList(where).then(res => {
        if (res.status) {
          this.articleList = res.data.list;
          console.log("this.articleList", this.articleList);
        }
      })
    },
    // 获取文章所有分类
    getArticleNav() {
      let where = {
        id: 1,

      };
      this.$api.articleTypeList(where).then(res => {
        if (res.status) {
          this.allcatList = res.data.list[1]['child'] && res.data.list ? res.data.list[1]['child'] : "";
          console.log("this.allcatList", this.allcatList);
        }
      })
    },



    //搜索品牌
    selectParams(id) {
      if (id == "all") {
        this.paramsList = [];
      } else {
        let index = this.paramsList.indexOf(id);
        console.log("indexindex",index);
        if (index > -1) {
          this.paramsList.splice(index, 1);
          delete this.searchOptions.where.params;
        } else {
          this.paramsList.push(id);
        }
      }

      let	 data = {
        page: 1,
        where: {
          params: this.paramsList
        }
      };

      console.log("this.paramsListdata",data);
      this.setSearchOptions(data, true);
      this.getGoodsList();
    },


    //设置筛选条件
    setSearchOptions: function(searchData, clear = false) {
      var sd = this.searchOptions;
      this.searchOptions = deepCopy(sd, searchData);
      if (clear) {
        this.goodsList = [];
      }
    },
    //分页
    handleCurrentChange(val) {
      console.log("val", val);
      this.setSearchOptions({
        page: val
      });
      this.getGoodsList();
    },
    handleParamsData(query) {
      console.log("handleParamsData");
      let where = {};
      if (query.key) {
        where = {
          search_name: query.key
        };
      }
      if (query.id) {
        where = {
          cat_id: query.id
        };
      }
      if (query.type) {
        if (query.type == "hot") {
          where = {
            hot: true
          };
        }
        if (query.type == "recommend") {
          where = {
            recommend: true
          };
        }
      }
      this.setSearchOptions({
        where: where
      });


      // this.categoriesTypeval();
      this.getAllParameters();
    },
    getAllParameters() {
      this.$api.getAllParameters().then(res => {
        if (res.status) {
          this.allParameters = res.data;
        }
      })
    },
    //获取商品列表

  },
  created() {
    let query = this.$route.query;
    console.log("query", query);
    this.handleParamsData(query);
    this.getArticleList();
    this.getArticleNav();
    this.getarticleInfo();
  },
  mounted() {


  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/product.scss";
.about_detail{
  img{ max-width: 100%}
}
</style>
